module.exports = __webpack_public_path__ + "static/media/register-background.16bf2196.svg";